import 'babel-polyfill' // polyfill promises and other ES6 features
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import filters from './filters'
import 'bootstrap/less/bootstrap.less'
import './foundations.css'
import './globalstyles.less'
import 'font-awesome/css/font-awesome.css'
import InstantSearch from 'vue-instantsearch'
import {useAirbrake} from './airbrake'

import {
  Popover,
  Dropdown,
  Modal,
  Collapse,
  Tooltip,
  Alert,
  Typeahead,
  DatePicker,
  Tabs,
  Tab,
  scrollspy
} from 'uiv'

// start analytics tracking and fetch user info
store
  .dispatch('initTracking')
  .then(() => {
    return store.dispatch('user/getUserInfo')
  })
  .then(data => {
    if (store.getters['user/isSuperAdmin']) {
      store.commit('visibility/toggleEditorMode', true)
    }
    if (store.getters['user/isTestUser']) {
      store.commit('visibility/toggleBetaMode', true)
    }
    if (store.getters['user/isAuthenticated']) {
      store.dispatch('library/fetchStudents', store.state.user.user.uuid)
      store.dispatch('library/fetchRecentStudents', store.state.user.user.uuid)
    }
    if (data && data.diagnostics) {
      // wrap this inside a try/catch so exceptions don't disrupt the flow of execution for the app
      try {
        document.getElementById('ci-build-info').innerHTML = `build ${data.diagnostics.build}, ${data.diagnostics.sha1}`
        console.info(data.diagnostics)
        store.commit('user/setDiagnostics', data.diagnostics)
      } catch {
        // do nothing
      }
    }
  })

// define global filters
Object.keys(filters).forEach(filter => {
  Vue.filter(filter, filters[filter])
})

Vue.component('modal', Modal)
Vue.component('dropdown', Dropdown)
Vue.component('popover', Popover)
Vue.component('collapse', Collapse)
Vue.component('tooltip', Tooltip)
Vue.component('alert', Alert)
Vue.component('typeahead', Typeahead)
Vue.component('datepicker', DatePicker)
Vue.component('tabs', Tabs)
Vue.component('tab', Tab)
Vue.directive('scrollspy', scrollspy)

import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

import vStickybits from '@/util/stickybits.directive'
Vue.directive('stickybits', vStickybits)

import vueSmoothScroll from '@/util/vue-smooth-scroll.directive'
Vue.use(vueSmoothScroll)

import { setAnalyticsEventHandler, setGetWebinarsHandler } from 'webinar-page'
import { sendEvent, GbAnalyticsPlugin } from '@/tracking'
Vue.use(GbAnalyticsPlugin)

Vue.use(InstantSearch)

import { getUpcomingWebinars } from '@/api/homepage'

setAnalyticsEventHandler(sendEvent)
setGetWebinarsHandler(getUpcomingWebinars)

Vue.config.productionTip = false

const routerWithAirbrake = useAirbrake(router)

import { RequestHandler } from './api/helpers'
import { showLoginModal } from './router/showLoginModal'

RequestHandler.setupHandleRequest(showLoginModal)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: routerWithAirbrake,
  store,
  render: h => h(App)
})
